import { useLang } from '@/app/utils/useLang';

export function getKrList() {
    const { t } = useLang('rapid.O2');

    return [
        {
            label: t('tab1'),
            value: 'wireless',
            desc: t('desc'),
            data: [
                {
                    name: '아이폰 16',
                    power: 90,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258795/16.png',
                },
                {
                    name: '아이폰 16 프로',
                    power: 88,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258174/16Pro.png',
                },
                {
                    name: '아이폰 16 프로 맥스',
                    power: 67,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743142160924/16ProMax.png',
                },
                {
                    name: '아이폰 15',
                    power: 95,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143257998/15.png',
                },
                {
                    name: '아이폰 15 프로',
                    power: 90,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258435/15Pro.png',
                },
                {
                    name: '아이폰 15 프로 맥스',
                    power: 73,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258611/15ProMax.png',
                },
            ],
        },
        {
            label: t('tab2'),
            value: 'wire',
            desc: t('desc2'),
            data: [
                {
                    name: '아이폰 16',
                    power: 100,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258795/16.png',
                },
                {
                    name: '아이폰 16 프로',
                    power: 98,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258174/16Pro.png',
                },
                {
                    name: '아이폰 16 프로 맥스',
                    power: 75,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743142160924/16ProMax.png',
                },
                {
                    name: '아이폰 15',
                    power: 100,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143257998/15.png',
                },
                {
                    name: '아이폰 15 프로',
                    power: 100,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258435/15Pro.png',
                },
                {
                    name: '아이폰 15 프로 맥스',
                    power: 91,
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258611/15ProMax.png',
                },
            ],
        },
        {
            label: t('tab3'),
            value: '10000 wireless',
            desc: t('desc3'),
            data: [
                {
                    name: '아이폰 16',
                    power: 1.61,
                    type: 'text',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258795/16.png',
                },
                {
                    name: '아이폰 16 프로',
                    power: 1.48,
                    type: 'text',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258174/16Pro.png',
                },
                {
                    name: '아이폰 16 프로 맥스',
                    power: 1.1,
                    type: 'text',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743142160924/16ProMax.png',
                },
                {
                    name: '아이폰 15',
                    power: 1.6,
                    type: 'text',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143257998/15.png',
                },
                {
                    name: '아이폰 15 프로',
                    power: 1.63,
                    type: 'text',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258435/15Pro.png',
                },
                {
                    name: '아이폰 15 프로 맥스',
                    power: 1.45,
                    type: 'text',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258611/15ProMax.png',
                },
            ],
        },
        {
            label: t('tab4'),
            value: '10000 wire',
            desc: t('desc4'),
            data: [
                {
                    name: '아이폰 16',
                    power: 1.97,
                    type: 'text',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258795/16.png',
                },
                {
                    name: '아이폰 16 프로',
                    power: 1.98,
                    type: 'text',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258174/16Pro.png',
                },
                {
                    name: '아이폰 16 프로 맥스',
                    power: 1.52,
                    type: 'text',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743142160924/16ProMax.png',
                },
                {
                    name: '아이폰 15',
                    power: 1.99,
                    type: 'text',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143257998/15.png',
                },
                {
                    name: '아이폰 15 프로',
                    power: 2,
                    type: 'text',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258435/15Pro.png',
                },
                {
                    name: '아이폰 15 프로 맥스',
                    power: 1.8,
                    type: 'text',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1743143258611/15ProMax.png',
                },
            ],
        },
    ];
}
